import { attributes } from "./constants";
export default function deserializeLookupTables({
  query,
  total,
  page,
  per_page,
  count,
  lookup_tables,
  caches,
  data_adapters
}) {
  var _a;
  return {
    attributes,
    list: (_a = lookup_tables.map((lut) => ({ ...lut, id: lut.id }))) != null ? _a : [],
    pagination: { total, page, per_page, count, query },
    meta: {
      caches,
      adapters: data_adapters
    }
  };
}
